import clsx from "clsx";
import { QueryBuilderContext } from "contexts/QueryBuilderContextProvider";
import moment from "moment-timezone";
import React, { useContext, useState } from "react";
import FilterSelect from "./Elements/FilterSelect/FilterSelect";
import QueryDataNew from "./Elements/QueryDataNew";

/**
 * The purpose of this component is to manage the state of the inpout search used while querying the API.
 * @param {*} props
 */
const QueryFilter = ({ queryDataProps, filterSelectProps }) => {
  const [searchValue, setSearchValue] = useState("");
  let { state } = useContext(QueryBuilderContext);
  const {
    field,
    fieldType,
    onChangeParent,
    index,
    type,
    choosedDimension,
    cleanFilter,
    choosedValue,
    tabNames,
    maxWidth,
    alwaysOpen,
    onLogicalOperatorChange,
    onSelectPrimitiveType,
    onApplyFilter,
    defaultLogicalOperator,
    onSetIsOpen,
    nextField,
    isFilterMenuOpen,
    renderRemoveFilterButton,
    filterIndex,
    removeFilter,
  } = filterSelectProps;

  /**
   * Clear the current searchValue and call the callback
   */
  const onClearInputSearch = () => {
    setSearchValue("");
  };

  // if the current filter is looking for its dimensions... inject the searchValue
  if (fieldType === "dimensions_items")
    queryDataProps.variables = {
      ...queryDataProps.variables,
      dimension_item_input_text: searchValue,
      // in the case the env is development, allows to request data without limit IF any key was introduced
      ...(searchValue.length > 1 ? { limit: undefined } : { limit: 1500 }),
      from: moment(state.queryOptions.startDate).format("YYYY-MM-DD"),
      to: moment(state.queryOptions.endDate).format("YYYY-MM-DD"),
    };

  return (
    <QueryDataNew {...queryDataProps}>
      {(data) => {
        let options = data.data ? data.data.meta : [];
        if (nextField.type === "dimensions")
          options = options
            .filter((el) => el.isFilterable)
            .sort((a, b) => (a.friendlyName > b.friendlyName ? 1 : -1));
        return (
          <span className="query-element mb-3">
            <FilterSelect
              data={options}
              loadingStatus={data.loadingStatus}
              setData={data.setData}
              fieldType={fieldType}
              onChangeParent={onChangeParent}
              index={index}
              type={type}
              choosedDimension={choosedDimension}
              dimensionType={field.valueType}
              cleanFilter={cleanFilter}
              choosedValue={choosedValue}
              tabNames={tabNames}
              maxWidth={maxWidth}
              alwaysOpen={alwaysOpen}
              onLogicalOperatorChange={onLogicalOperatorChange}
              onSelectPrimitiveType={onSelectPrimitiveType}
              onApplyFilter={onApplyFilter}
              defaultLogicalOperator={defaultLogicalOperator}
              onSetIsOpen={onSetIsOpen}
              onChangeValueInput={setSearchValue}
              onClearInputSearch={onClearInputSearch}
              removeFilter={removeFilter}
              filterIndex={filterIndex}
            />
            {!isFilterMenuOpen && (
              <div
                className={clsx(
                  "filter-remove-button-container",
                  isFilterMenuOpen && "filter-remove-button-container-opened"
                )}
              >
                {renderRemoveFilterButton(filterIndex)}
              </div>
            )}
          </span>
        );
      }}
    </QueryDataNew>
  );
};

export default QueryFilter;
